export enum ColorsAll {
  PM900 = '#063825',
  PMSecondary900 = '#785725',
  PMTertiary900 = '#04485c',
  PMSuccess900 = '#062625',
  PM700 = '#0A5334',
  PMSecondary800 = '#99712C',
  PMTertiary800 = '#08647D',
  PMSuccess800 = '#0D4B47',
  PM600 = '#0F6E42',
  PMSecondary700 = '#BA8D33',
  PMTertiary700 = '#0D7F9C',
  PMSuccess700 = '#157066',
  PM500 = '#15874E',
  PMSecondary600 = '#DCAB38',
  PMTertiary600 = '#129BBB',
  PMSuccess600 = '#1E9383',
  PM400 = '#4AA173',
  PMSecondary500 = '#FFCB3C',
  PMTertiary500 = '#19B6D8',
  PMSuccess500 = '#28B59C',
  PM300 = '#7FBC9A',
  PMSecondary400 = '#FED969',
  PMTertiary400 = '#4EC3E0',
  PMSuccess400 = '#59C5AF',
  PM200 = '#B4D7C2',
  PMSecondary300 = '#FEE695',
  PMTertiary300 = '#82D2E8',
  PMSuccess300 = '#8AD5C4',
  PM100 = '#E8F3EC',
  PMSecondary200 = '#FEF1C1',
  PMTertiary200 = '#B5E3F1',
  PMSuccess200 = '#BAE6DA',
  PMSecondary100 = '#FFFBEC',
  PMTertiary100 = '#E9F6FB',
  PMSuccess100 = '#EAF7F3',

  PMDanger900 = '#5D0D0E',
  PMWarning900 = '#592C0B',
  PMInfo900 = '#1B3F59',
  PMGray900 = '#25272D',
  PMDanger800 = '#891517',
  PMWarning800 = '#834816',
  PMInfo800 = '#2C5483',
  PMGray800 = '#3A3E47',
  PMDanger700 = '#B41F21',
  PMWarning700 = '#AC6825',
  PMInfo700 = '#4066AC',
  PMGray700 = '#505462',
  PMDanger600 = '#DE2A2C',
  PMWarning600 = '#D68A38',
  PMInfo600 = '#5877D6',
  PMGray600 = '#666B7B',
  PMDanger500 = '#E85153',
  PMWarning500 = '#FEAE4F',
  PMInfo500 = '#7288FF',
  PMGray500 = '#7C8195',
  PMDanger400 = '#F17A7B',
  PMWarning400 = '#FDC677',
  PMInfo400 = '#92A7FE',
  PMGray400 = '#7C8195',
  PMDanger300 = '#F7A4A5',
  PMWarning300 = '#FDDB9F',
  PMInfo300 = '#B2C3FE',
  PMGray300 = '#C8CBD9',
  PMDanger200 = '#FCD1D1',
  PMWarning200 = '#FEECC7',
  PMInfo200 = '#B2C3FE',
  PMGray200 = '#F0F1F7',
  PMDanger100 = '#FFF6F5',
  PMWarning100 = '#FFFAEE',
  PMInfo100 = '#B2C3FE',
  PMGray100 = '#FAFAFC'
}

export enum Colors {
  purple = '#571D5D',
  red = '#ed002b',
  light_info = '#9DCAFE',
  info = '#1D4570',
  light_warning = '#FDDEA4',
  dark_warning = '#965307',
  background_gray = '#F0F1F7',
  white = '#fff',
  gray = '#7C8195',
  grayWords = '#6B6B84',
  black = '#25272D',
  success = '#4fce5d',
  warn = '#FEB647'
}

export enum linguagens {
  background = '#FEDAD7',
  color = '#A0434A',
  before = '#FF7272'
}

export enum natureza {
  background = '#D6EDEA',
  color = '#2B4F46',
  before = '#70C1B3'
}

export enum redacao {
  background = '#FCD0AA',
  color = '#663A21',
  before = '#FC9F5B'
}

export enum humanas {
  background = '#FDF9D9',
  color = '#66582D',
  before = '#FAE278'
}

export enum matematica {
  background = '#CEE3EE',
  color = '#1F4752',
  before = '#53A4C6'
}

export enum comum {
  background = '#BCA5BE',
  color = '#1F0222'
}
